import { SobaLoading } from 'app/components';
import { Suspense } from 'react';

const SobaSuspense = ({ children }) => {
  return <Suspense fallback={<SobaLoading />}>{children}</Suspense>;
};

export default SobaSuspense;
